import Page from '../classes/Page';

const regularPage = new Page({
  name: 'regular',
  rootElementId: 'js-page-regular'
});

export default regularPage;
